import { createAction, props } from '@ngrx/store';
import { IOversignTime } from '../IOversignTime';
import { Update } from '@ngrx/entity';

export const getOversignTimes = createAction(
  '[OversignTime/API] Get OversignTimes',
  props<{ EmployeeListID: string }>());

export const putOversignTimes = createAction(
  '[TimeCard/API] Update OversignTime',
  props<{ oversignTime: Array<IOversignTime> }>()
);

// these are only for manipulating the store collection, not for effects, i.e. loading from a service // For reducer

export const loadOversignTimes = createAction(
  '[OversignTime/API] Load OversignTimes',
  props<{ oversignTimes: IOversignTime[] }>()
);

export const addOversignTime = createAction(
  '[OversignTime/API] Add OversignTime',
  props<{ oversignTime: IOversignTime }>()
);

export const upsertOversignTime = createAction(
  '[OversignTime/API] Upsert OversignTime',
  props<{ oversignTime: IOversignTime }>()
);

export const addOversignTimes = createAction(
  '[OversignTime/API] Add OversignTimes',
  props<{ oversignTimes: IOversignTime[] }>()
);

export const upsertOversignTimes = createAction(
  '[OversignTime/API] Upsert OversignTimes',
  props<{ oversignTimes: IOversignTime[] }>()
);

export const updateOversignTime = createAction(
  '[OversignTime/API] Update OversignTime',
  props<{ oversignTime: Update<IOversignTime> }>()
);

export const updateOversignTimes = createAction(
  '[OversignTime/API] Update OversignTimes',
  props<{ oversignTimes: Update<IOversignTime>[] }>()
);

export const deleteOversignTime = createAction(
  '[OversignTime/API] Delete OversignTime',
  props<{ id: string }>()
);

export const deleteOversignTimes = createAction(
  '[OversignTime/API] Delete OversignTimes',
  props<{ ids: string[] }>()
);

export const clearOversignTimes = createAction(
  '[OversignTime/API] Clear OversignTimes'
);

export const loadOversignTimesSuccess = createAction(
  '[OversignTime] Load OversignTimes Success',
  props<{ data: any }>()
);

export const loadOversignTimesFailure = createAction(
  '[OversignTime] Load OversignTimes Failure',
  props<{ error: any }>()
);
